export const NOTIFY_ME_ON_UPDATE_API_REQUEST = 'NOTIFY_ME_ON_UPDATE_API_REQUEST';
export const NOTIFY_ME_ON_UPDATE_API_ERROR = 'NOTIFY_ME_ON_UPDATE_API_ERROR';
export const NOTIFY_ME_ON_UPDATE_API_SUCCESS = 'NOTIFY_ME_ON_UPDATE_API_SUCCESS';
